import { encodePageUrlasBase64 } from '../components/retry/utils';
import { Locale, ShopBundle } from '../types';

import GenericApiAdapter from './genericApiAdapter';
import {
  InitiatePaymentProcessRequestData,
  InitiatePaymentRequestData,
  RetryPaymentDataAPIResponse,
  RetryPaymentResponse,
  RetryProcessAuthorisationResponse,
} from './retryApiAdapter.types';

export default class RetryPaymentApiAdapter {
  private apiAdapter: GenericApiAdapter;
  private domain: string;
  private locale: Locale;

  public constructor(apiBaseUrl: string, domain: string, locale: Locale) {
    this.apiAdapter = new GenericApiAdapter(apiBaseUrl, {});
    this.domain = domain;
    this.locale = locale;
  }

  private async get<T>(url: string, headers: object = {}, queryParams?: object): Promise<T> {
    const newHeaders = {
      ...headers,
      'Content-type': 'application/json',
      'X-Original-Host': this.domain,
      'Accept-Language': this.locale,
    };
    const response = await this.apiAdapter.get(url, newHeaders, queryParams);
    return response as T;
  }

  private async post<T>(url: string, body: RequestInit['body'], headers: object = {}): Promise<T> {
    const newHeaders = {
      ...headers,
      'Content-type': 'application/json',
      'X-Original-Host': this.domain,
      'Accept-Language': this.locale,
    };
    const response = await this.apiAdapter.post(url, body, newHeaders);
    return response as T;
  }

  public async getRetryPaymentData(
    customerId: string,
    orderId: string,
    shopBundle: ShopBundle,
  ): Promise<RetryPaymentDataAPIResponse> {
    const pathUrlBase64 = encodePageUrlasBase64();
    return this.get<RetryPaymentDataAPIResponse>(
      `/${customerId}/handle-retry-payment/${orderId}/${shopBundle}`,
      undefined,
      { originalURL: pathUrlBase64 },
    );
  }

  public async initiatePayment(payload: InitiatePaymentRequestData): Promise<RetryPaymentResponse> {
    return this.post('/initiate-retry-payment', payload as any);
  }

  public async processPaymentAuthorization(
    payload: InitiatePaymentProcessRequestData,
  ): Promise<RetryProcessAuthorisationResponse> {
    return this.post('/initiate-process-psp-response', payload as any);
  }
}
